<template>
  <div class="forgot-password">
    <IconSwitch :type="'qrcode'"></IconSwitch>
    <Icon></Icon>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <div class="title">{{$route.query.account}}</div>
    <div class="code">
      <Inputs :type="'code'" style="width: 180px;margin-top: 0;float:left;" v-on:inputText="getCode" v-on:enterInput="enterInput"></Inputs>
      <GetCode :type="1" :data="{'countryCode': $route.query.countryCode, 'phone': $route.query.account}" style="float: right;"></GetCode>
    </div>
    <Inputs :type="'newpassword'" v-on:inputText="getPassword" v-on:enterInput="enterInput"></Inputs>
    <Buttons ref=btn :type="'reset'" :data="{code: code, password: password}" v-on:openErrorTip="openErrorTip" v-on:closeErrorTip="closeErrorTip" style="margin-top: 30px;"></Buttons>
    <Foot :type="'or Sign in'" :isEmail="isEmail ? true : false" style="margin-top: 25px;margin-bottom: 45px;"></Foot>
  </div>
</template>

<script>
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Error from '../components/Error'
  import Account from '../components/Account'
  import Inputs from '../components/Inputs'
  import GetCode from '../components/GetCode'
  import Buttons from '../components/Buttons'
  import Foot from '../components/Foot'
  import { errorFn } from '../common/ErrorMsg.js'
  export default {
    data () {
      return {
        errorShow: false,
        errorMsg: '',
        code: '',
        password: '',
        isEmail: this.$route.query.isEmail
      }
    },
    components: {
      IconSwitch, Icon, Error, Account, Inputs, GetCode, Buttons, Foot
    },
    mounted () {
    },
    methods: {
      getCode (data) {
        this.code = data
      },
      getPassword (data) {
        this.password = data
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      }
    }
  }
</script>

<style lang="less" scoped>
	@import '../../assets/css/_mixin.less';
  .forgot-password {
    .white-bg();
    min-height: 460px;
    margin-top: -230px;
    .title {
      width: 300px;
      margin: 0 auto;
      margin-top: 30px;
    }
    .code {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 45px;
    }
  }
</style>



// WEBPACK FOOTER //
// Forgotpassword.vue?78843bb2